export default {
  SET_NAME_IMAGE(state, payload) {
    state.nameImage = payload
  },
}
